










import { Component, Vue } from 'vue-property-decorator';
import Capture from '@/components/room/status/Capture.vue';
import CallStatus from '@/components/room/status/callStatus/CallStatus.vue';
import SelfStatus from '@/components/room/status/SelfStatus.vue';
import ExitButton from '@/components/room/status/ExitButton.vue';
import ChatList from '@/components/room/status/chatList/ChatList.vue';
import { store } from '@/utils/store';

@Component({
  components: {
    Capture,
    CallStatus,
    SelfStatus,
    ExitButton,
    ChatList,
  },
})
export default class Status extends Vue {
  get calling() {
    return !!store.callId;
  }
}
